import { createBrowserClient } from "@supabase/ssr";
import { getSupabaseBrowserKey, getSupabaseUrl } from "./env";

// autoRefreshToken is disabled: the middleware (utils/supabase/middleware.ts)
// already refreshes the session server-side on every matched request. Running
// a second refresher in the browser means two clients racing to rotate the
// same refresh token at expiry — with GoTrue refresh-token rotation enabled
// that race can trip reuse detection and sign everyone out. Single refresher
// client-side + GOTRUE_SECURITY_REFRESH_TOKEN_REUSE_INTERVAL=10 server-side.
export const createClient = () =>
  createBrowserClient(getSupabaseUrl(), getSupabaseBrowserKey(), {
    auth: { autoRefreshToken: false },
  });
